// Mock data for Colombian structural engineering services

export const mockServices = [
  {
    id: 1,
    title: "Cálculos Residenciales",
    description: "Análisis estructural completo para viviendas unifamiliares y multifamiliares",
    icon: "building",
    features: ["Estudio de suelos","Cimentación", "Estructura en concreto", "Estructura metálica", "Análisis sísmico"]
  },
  {
    id: 2,
    title: "Estructuras Comerciales",
    description: "Diseño y cálculo para edificios comerciales e industriales",
    icon: "factory",
    features: ["Grandes luces", "Cargas industriales", "Norma NSR-10 y ACI", "Optimización de costos"]
  },
  {
    id: 3,
    title: "Vulnerabilidad y Reforzamiento",
    description: "Análisis de vulnerabilidad sísmica y diseño de reforzamiento estructural",
    icon: "users",
    features: ["Revisión de diseños", "Evaluación sísmica", "Estudios de patología", "Reforzamiento estructural"]
  },
  {
    id: 4,
    title: "Estudio de Suelos",
    description: "Caracterización geotécnica completa para proyectos de construcción",
    icon: "layers",
    features: ["Análisis de Laboratorio", "Evaluación de Estabilidad de Taludes", "Caracterización geotécnica", "Capacidad portante", "Estudios de licuefacción", "Recomendaciones de cimentación"]
  }
];

export const mockProjects = [
   {
     id: 1,
     title: "projects.items.1.title",
     location: "projects.items.1.location",
     type: "industrial",
     floors: 15,
     description: "projects.items.1.description",
     image: "https://i.ibb.co/0pttD0F1/vivienda-campestre-1.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/0pttD0F1/vivienda-campestre-1.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/bM4qZT83/vivienda-campestre-2.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/Zpznk3Y7/vivienda-campestre-3.png?w=800&h=800&fit=crop"
     ]
   },
   {
     id: 2,
     title: "projects.items.2.title",
     location: "projects.items.2.location",
     type: "industrial",
     floors: 3,
     description: "projects.items.2.description",
     image: "https://i.ibb.co/gMFBzn2w/image-2025-10-19-001542612.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/gMFBzn2w/image-2025-10-19-001542612.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/5hBFwJRg/image-2025-10-19-004101448.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/1GbX5cNF/image-2025-10-19-004143714.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 3,
     title: "projects.items.3.title",
     location: "projects.items.3.location",
     type: "industrial",
     floors: 1,
     description: "projects.items.3.description",
     image: "https://i.ibb.co/N6HrfP6f/gamp.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/N6HrfP6f/gamp.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/PZHfvdgN/gamp-2.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/HjjZYZp/wmremove-transformed-5-1.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 4,
     title: "projects.items.4.title",
     location: "projects.items.4.location",
     type: "commercial",
     floors: 20,
     description: "projects.items.4.description",
     image: "https://i.ibb.co/V0TntbrL/image-2025-10-19-013737220.png?w=600&h=600&",
     images: [
       "https://i.ibb.co/V0TntbrL/image-2025-10-19-013737220.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/MkfMBc0G/image-2025-10-19-013853499.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 5,
     title: "projects.items.5.title",
     location: "projects.items.5.location",
     type: "residential",
     floors: 12,
     description: "projects.items.5.description",
     image: "https://i.ibb.co/spXJFmzt/image-2025-10-19-014511998.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/spXJFmzt/image-2025-10-19-014511998.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/Rpfbtm0X/image-2025-10-19-014604491.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 6,
     title: "projects.items.6.title",
     location: "projects.items.6.location",
     type: "residential",
     floors: 8,
     description: "projects.items.6.description",
     image: "https://i.ibb.co/ycNFRqP7/image-2025-10-19-014642180.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/ycNFRqP7/image-2025-10-19-014642180.png?w=800&h=600&fit=crop",
       "https://i.ibb.co/1tMJ5Jpv/image-2025-10-19-014710551.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 7,
     title: "projects.items.7.title",
     location: "projects.items.7.location",
     type: "industrial",
     floors: 1,
     description: "projects.items.7.description",
     image: "https://i.ibb.co/DHsnSyVD/default-to-projects.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/DHsnSyVD/default-to-projects.png?w=800&h=600&fit=crop"
     ]
   },
   {
     id: 8,
     title: "projects.items.8.title",
     location: "projects.items.8.location",
     type: "residential",
     floors: 18,
     description: "projects.items.8.description",
     image: "https://i.ibb.co/DHsnSyVD/default-to-projects.png?w=500&h=300&fit=crop",
     images: [
       "https://i.ibb.co/DHsnSyVD/default-to-projects.png?w=800&h=600&fit=crop"
     ]
   }
 ];

export const mockTeam = [
  {
    id: 1,
    name: "Ing. Giovani Paz Portilla",
    title: "team.members.1.title",
    experience: "20+",
    education: "team.members.1.education",
    projects: "5000+",
    image: "https://i.ibb.co/BHBBFz6C/Giovanni-paz.png"
  },
  {
    id: 2,
    name: "Ing. Hugo Paz Pantoja",
    title: "team.members.2.title",
    experience: "5+",
    education: "team.members.2.education",
    projects: "500+",
    image: "https://i.ibb.co/G35BnJhB/hugo-paz.jpg"
  },
  {
    id: 3,
    name: "Ing. Sebastian Gonzales",
    title: "team.members.3.title",
    experience: "5+",
    education: "team.members.3.education",
    projects: "300+",
    image: "https://i.ibb.co/tMwD38Wt/sebastian-gonzales-copy.png"
  },
    {
    id: 4,
    name: "Ing. Elizabeth Paz Pantoja",
    title: "team.members.4.title",
    experience: "5+",
    education: "team.members.4.education",
    projects: "500+",
    image: "https://i.ibb.co/wNzrjpSK/elizabeth-paz.jpg"
  }, 
      {
    id: 5,
    name: "Ing. Karina Paz Pantoja",
    title: "team.members.5.title",
    experience: "5+",
    education: "team.members.5.education",
    projects: "300+",
    image: "https://i.ibb.co/Pb5TK03/Karina-Paz.jpg"
  }
];

export const mockCompanyInfo = {
  name: "Gheika Ingenieros ",
  tagline: "Ingeniería Estructural de Tradición y Confianza",
  description: "Con más de veinte años de experiencia, somos especialistas en cálculos estructurales para proyectos residenciales, comerciales e industriales en Colombia. Nuestros ingenieros civiles combinan tradición, experiencia y tecnología de vanguardia aplicando las normas NSR-10 y ACI.",
  stats: [
    { label: "Años de Experiencia", value: "20+" },
    { label: "Proyectos Completados", value: "500+" },
    { label: "Ciudades Atendidas", value: "50+" },
    { label: "Suelos estudiados", value: "2000+" }
  ],
  contact: {
    phone: "3017891934 - 3146269802",
    email: "gheikaingenieros@gmail.com",
    address: "Carrera 31 Calle 19-445, Medellín",
    whatsapp: "+573017891934",
    socialMedia: {
      instagram: "https://www.instagram.com/gheikaingenieros",
      linkedin: "https://www.linkedin.com/in/gheika-ingenieriacivil"
    }
  }
};